import { DateTime } from 'luxon'
import { ModerationEvent } from '../api/models'

type GroupedEvents<T> = {
  [date: string]: T[]
}

export const groupAndSortEvents = <T extends ModerationEvent>(events: T[]): GroupedEvents<T> => {
  // Sort in reverse chronological order
  const sorted = [...events].sort((a, b) => DateTime.fromISO(b.createdAt.toString()).toMillis() - DateTime.fromISO(a.createdAt.toString()).toMillis())

  // Group by formatted date
  const grouped: GroupedEvents<T> = {}

  for (const event of sorted) {
    const dateKey = DateTime.fromISO(event.createdAt.toString()).toFormat('MM/dd/yy')

    if (!grouped[dateKey]) {
      grouped[dateKey] = []
    }

    grouped[dateKey].push(event)
  }

  return grouped
}
